import React, { useEffect, useState } from 'react'
import { useAxios } from '../../../hooks/useAxios';

export const useComments = ( {counter = 0, comentarios, friendlyTag, totale=3} ) => {

    const [comments, setComments] = useState( comentarios );
    const [url, setUrl] = useState(null)
    
    const { data, isLoading, error } = useAxios(url);

    useEffect(() => {
        if(data){
            setComments( data );
        }else {
        }
    }, [data]);
    
    useEffect(() => {
        if(counter > 0) {
            setUrl(`/comments/byfriendly/${ friendlyTag }?offset=${ counter * totale }&limit=${ totale }`);
        }else {
            setComments( comentarios );
            setUrl(null);
        }
    },[counter, totale]);

    return {
        comments,
        isLoading,
        error,
    };
}